export const IOS_APP_ID = '6779888256';
export const ANDROID_PACKAGE = 'com.daeat.app';

export const APP_STORE_URL = `https://apps.apple.com/kr/app/%EB%8B%A4%EC%9E%87/id${IOS_APP_ID}`;
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}&pcampaignid=web_share`;

/** QR이 가리키는 곳. /app이 OS를 판별해 해당 스토어로 바로 보낸다. */
export const APP_REDIRECT_URL = 'https://www.da-eat.com/app';

/**
 * 설치 배너용 OS 판별. 데스크톱은 null.
 * iPadOS 13+는 UA에 iPad가 없고 Mac으로 위장하므로 터치 지원 여부로 가른다.
 */
export function getMobileOS() {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return 'ios';
  return null;
}

export function storeUrlFor(os) {
  if (os === 'ios') return APP_STORE_URL;
  if (os === 'android') return PLAY_STORE_URL;
  return null;
}
